var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    "aria-hidden": "true",
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05929 15.3853C13.0986 15.3853 16.3848 12.0991 16.3848 8.05985C16.3848 4.02057 13.0986 0.734375 9.05929 0.734375C5.02 0.734375 1.7338 4.02057 1.7338 8.05985C1.7338 12.0991 5.02 15.3853 9.05929 15.3853Z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05947 1.46837C12.6939 1.46837 15.6508 4.42522 15.6508 8.05967C15.6508 11.6941 12.6939 14.651 9.05947 14.651C5.42502 14.651 2.46818 11.6941 2.46818 8.05967C2.46818 4.42522 5.42502 1.46837 9.05947 1.46837ZM9.05947 0C4.60824 0 0.999804 3.60844 0.999804 8.05967C0.999804 12.5109 4.60824 16.1193 9.05947 16.1193C13.5107 16.1193 17.1191 12.5109 17.1191 8.05967C17.1191 3.60844 13.5107 0 9.05947 0Z",
    fill: "#787860"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4302 13.4336L19.7012 18.7048",
    stroke: "#787860",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.3e071bb1.svg";
export { ForwardRef as ReactComponent };